import { render, staticRenderFns } from "./EmployeePpeShipments.vue?vue&type=template&id=2d0cc9da&scoped=true&"
import script from "./EmployeePpeShipments.vue?vue&type=script&lang=js&"
export * from "./EmployeePpeShipments.vue?vue&type=script&lang=js&"
import style0 from "./EmployeePpeShipments.vue?vue&type=style&index=0&id=2d0cc9da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0cc9da",
  null
  
)

export default component.exports